import React from 'react';

export interface AspectRatioOption {
  id: number;
  name: string;
  ratio: number;
}

interface AspectRatioSelectorProps {
  aspectRatios: AspectRatioOption[];
  selectedAspectRatioId: number | null;
  onAspectRatioChange: (aspectRatioId: number, ratio: number) => void;
}

const AspectRatioSelector: React.FC<AspectRatioSelectorProps> = ({
  aspectRatios,
  selectedAspectRatioId,
  onAspectRatioChange
}) => {
  if (aspectRatios.length === 0) {
    return (
      <div className="aspect-ratio-selector">
        <h3>Choose Aspect Ratio</h3>
        <p className="help-text">Loading aspect ratios...</p>
      </div>
    );
  }

  return (
    <div className="aspect-ratio-selector">
      <h3>Choose Aspect Ratio</h3>
      <p className="help-text">Select the aspect ratio for your crop. This will lock the crop proportions.</p>
      <div className="aspect-ratio-grid">
        {aspectRatios.map((ar) => (
          <button
            key={ar.id}
            type="button"
            className={`aspect-ratio-option ${selectedAspectRatioId === ar.id ? 'selected' : ''}`}
            onClick={() => onAspectRatioChange(ar.id, ar.ratio)}
          >
            <div className="aspect-ratio-preview">
              <div 
                className="aspect-ratio-box"
                style={{ 
                  aspectRatio: ar.ratio,
                  backgroundColor: selectedAspectRatioId === ar.id ? 'var(--color-teal)' : 'var(--border-color)',
                  border: `2px solid ${selectedAspectRatioId === ar.id ? 'var(--color-teal)' : 'transparent'}`,
                  minHeight: '60px'
                }}
              />
            </div>
            <div className="aspect-ratio-label">{ar.name || `Aspect ${ar.id}`}</div>
            <div className="aspect-ratio-value">{ar.ratio.toFixed(2)}:1</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AspectRatioSelector;
